export default "__VITE_ASSET__DxdJIqYF__"